
import React, { useEffect, useState } from 'react';
import PhotoIcons from './../PhotoIcons/PhotoIcons';
import { Card } from 'react-bootstrap';
import defaultIcon from './../../assets/images/icons/service-icon.png'; // TODO: Get an official default icon 
import styles from './AssetCard.module.css';
const classNames = require('classnames');


export default ({ title, subtitle, iconType, onClick, className, photos }) => {
  const [cardIcon, setCardIcon] = useState(defaultIcon);

  // dynamically load the appropriate icon image
  useEffect(() => {
    import(`./../../assets/images/icons/${iconType}-icon.png`).then(module => {
      setCardIcon(module.default);
    }).catch(() => console.warn(`Icon type of ${iconType} not found. Using default icon.`));

  }, [iconType]);
  
  return (
    <Card className={classNames(styles.sideImgCard, className)} onClick={onClick}>
      <div className="d-flex justify-content-start align-items-center">
        <div className='mr-3'>
          <img src={cardIcon} className="card-img" alt="" />
        </div>
        <div>
          <Card.Body className={styles.cardBody}>
            <Card.Title className={styles.cardTitle}>{title}</Card.Title>
            <Card.Subtitle className={styles.cardSubtitle}>{subtitle}</Card.Subtitle>
            <PhotoIcons photos={photos} />
          </Card.Body>
        </div>
      </div>
    </Card>
  );
}
